/** Build landing nav, FAQ, and feature cards from t(). */

const FEATURE_META = [
  { id: 'inventory', icon: '📦' },
  { id: 'pos', icon: '🛒' },
  { id: 'analytics', icon: '📈' },
  { id: 'reporting', icon: '📊' },
  { id: 'quotation', icon: '🧾' },
  { id: 'proforma', icon: '📑' },
  { id: 'invoice', icon: '📄' },
  { id: 'receipt', icon: '🖨️' },
  { id: 'efd', icon: '🏷️' },
  { id: 'expenses', icon: '💸' },
  { id: 'debt', icon: '🔔' },
  { id: 'business-pl', icon: '💼' },
  { id: 'wakala', icon: '💰' },
];

export function getPublicNavLinks(t) {
  return [
    { key: 'home', label: t('public.nav.home') },
    { key: 'features', label: t('public.nav.features') },
    { key: 'industries', label: t('public.nav.industries') },
    { key: 'faq', label: t('public.nav.faq') },
    { key: 'support', label: t('public.nav.support') },
  ];
}

export function getLandingFaq(t) {
  return [
    { q: t('public.faq.trial.q'), a: t('public.faq.trial.a') },
    { q: t('public.faq.safe.q'), a: t('public.faq.safe.a') },
    { q: t('public.faq.pay.q'), a: t('public.faq.pay.a') },
    { q: t('public.faq.branches.q'), a: t('public.faq.branches.a') },
    { q: t('public.faq.upgrade.q'), a: t('public.faq.upgrade.a') },
    { q: t('public.faq.expire.q'), a: t('public.faq.expire.a') },
    { q: t('public.faq.swahili.q'), a: t('public.faq.swahili.a') },
  ];
}

export function getLandingFeatureCards(t) {
  return FEATURE_META.map(({ id, icon }) => ({
    id,
    icon,
    title: t(`public.feat.${id}.title`),
    desc: t(`public.feat.${id}.desc`),
  }));
}
